export const companies = [
  {
    name: "G.A.D. Produkcija",
    logo: "/companyImages/gadlogo.png",
    url: "https://www.gad.hr/",
    category: [
      "Marketing i kreativne usluge",
      "G.A.D.",
      "GAD",
      "event",
      "eventi",
      "produkcija",
      "AV",
      "audiovizualno",
      "rasvjeta",
      "ozvučenje",
      "svadbe",
      "svadba",
      "niski dim",
      "prskalice",
    ],
  },
  {
    name: "Herlig International",
    logo: "/companyImages/Herligremovebgpreview.png",
    url: "https://herliginternational.com/",
    category: [
      "Trgovina i prodaja",
      "Alati i oprema",
      "Herlig International",
      "Herlig",
      "alat",
      "alati",
      "profesionalni alat",
      "industrijski alat",
      "oprema",
      "industrijska oprema",
      "radionica",
      "radionička oprema",
      "zaštita",
      "zaštita na radu",
      "rezanje",
      "bušenje",
      "glodanje",
      "tokarenje",
      "brušenje",
      "mjerenje",
      "metrologija",
      "CNC",
      "proizvodnja",
      "obrada metala",
      "metalna industrija",
      "servis",
      "održavanje",
    ],
  },
  {
    name: "A-Team",
    logo: "/companyImages/aTeamremovebgpreview.png",
    url: "https://www.facebook.com/ateameffect?locale=hr_HR",
    category: [
      "Marketing i kreativne usluge",
      "A-Team",
      "Ateam",
      "tim",
      "event",
      "eventi",
      "rasvjeta",
      "svadba",
      "svadbe",
      "niski dim",
      "prskalice",
    ],
  },
  {
    name: "EU Shipments Croatia",
    logo: "/companyImages/pnp.svg",
    url: "https://eushipments.com/hr/",
    category: [
      "Logistika i transport",
      "pnp",
      "euShipments",
      "EU Shipments",
      "eushipments.com",
      "paket",
      "paketi",
      "pošiljka",
      "pošiljke",
      "dostava",
      "transport",
      "logistika",
      "kurir",
      "kurirska služba",
      "špedicija",
      "fulfillment",
      "3PL",
      "skladište",
      "skladištenje",
      "distribucija",
      "otprema",
      "pakiranje",
      "praćenje pošiljke",
      "tracking",
      "eCommerce",
      "web shop",
      "online trgovina",
      "B2B",
      "COD",
      "pouzećem",
    ],
  },
  {
    name: "K-destilery",
    logo: "/companyImages/kdestilery-removebg-preview.png",
    url: "https://www.instagram.com/k_distillery_/",
    category: [
      "Hrana i piće",
      "K Distillery",
      "K DISTILLERY",
      "K Distillery d.o.o.",
      "K London Dry Gin",
      "K Gin",
      "K Gin Hrvatska",
      "gin",
      "gini",
      "alkohol",
      "alkoholno piće",
      "piće",
      "destilat",
      "destilati",
      "rakija",
      "liker",
      "boce",
      "premium piće",
      "craft",
      "domaće",
      "hrvatsko",
      "lokalno",
      "proizvođač",
      "proizvodnja",
      "destiler",
      "destilerija",
      "kušanje",
      "degustacija",
      "koktel",
      "bar",
    ],
  },
  {
    name: "Domaća Priča",
    logo: "/companyImages/domacaprica-removebg-preview.png",
    url: "https://www.instagram.com/domaca_prica__/",
    category: [
      "Trgovina i prodaja",
      "Hrana i piće",
      "Domaća priča",
      "Domaca prica",
      "domaća priča Hrvatska",
      "domaći proizvodi",
      "hrvatski proizvodi",
      "hrana",
      "namirnice",
      "proizvodi",
      "domaće",
      "lokalno",
      "tradicija",
      "delicije",
      "proizvođač",
      "pekmez",
      "sok",
      "rakija",
      "vino",
      "poklon",
      "košara",
      "trgovina",
      "med",
    ],
  },
  {
    name: "Nibiru",
    logo: "/companyImages/nibiruLogo.png",
    url: "https://www.instagram.com/caffee.bar.nibiru?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    category: [
      "Ugostiteljstvo i turizam",
      "Nibiru",
      "Caffe bar Nibiru",
      "Caffee bar Nibiru",
      "Nibiru Karlovac",
      "kafić",
      "kafic",
      "caffe",
      "cafe",
      "bar",
      "coffee",
      "kava",
      "piće",
      "napitak",
      "espresso",
      "pivo",
      "vino",
      "koktel",
      "druženje",
      "izlazak",
      "pauza",
      "terasa",
      "lokal",
      "ugostitelj",
      "event",
      "svirke",
      "svirka",
      "događanja",
      "događaji",
    ],
  },
  {
    name: "The Legacy of Motörhead",
    logo: "/companyImages/motorheadtributelogo2.png",
    url: "https://thelegacyofmotorhead.com/",
    category: [
      "Glazba i zabava",
      "The Legacy of Motörhead",
      "The Legacy of Motorhead",
      "Motörhead",
      "Motorhead",
      "Legacy of Motorhead",
      "Motörhead tribute",
      "Motorhead tribute band",
      "bend",
      "glazba",
      "rock",
      "metal",
      "hard rock",
      "tribute",
      "cover",
      "koncert",
      "nastup",
      "festival",
      "motorijada",
      "bikeri",
      "event",
      "zabava",
      "live",
      "muzika",
      "muzika uživo",
    ],
  },
  {
    name: "Kolibrić",
    logo: "/companyImages/kolibriclogo.png",
    url: "#",
    category: [
      "Gradnja, adaptacije i instalacije",
      "Kolibrić",
      "Kolibric",
      "knauf radovi",
      "vodoinstalacije",
      "grijanje",
      "centralno grijanje",
      "klimatizacija",
      "knauf",
      "gips",
      "gips karton",
      "zid",
      "strop",
      "vodoinstalater",
      "voda",
      "cijevi",
      "grijanje",
      "centralno",
      "radijator",
      "bojler",
      "klima",
      "klimatizacija",
      "montaža",
      "servis",
      "adaptacija",
      "obnova",
      "građevina",
      "majstor",
    ],
  },
  {
    name: "Najam stanova i kuća Karlovac",
    logo: "/companyImages/najamkucastanova.jpg",
    url: "https://www.facebook.com/groups/193833341176846?locale=hr_HR",
    category: [
      "Nekretnine i najam",
      "najam stanova",
      "najam kuća",
      "iznajmljivanje nekretnina",
      "oglasi nekretnina",
      "stambene nekretnine",
      "Najam stanova i kuća Karlovac",
      "najam stanova Karlovac",
      "najam kuća Karlovac",
      "nekretnine Karlovac",
      "stan",
      "kuća",
      "nekretnina",
      "najam",
      "najam stana",
      "najam kuće",
      "podstanar",
      "iznajmljivanje",
      "oglas",
      "tražim",
      "ponuda",
      "smještaj",
      "soba",
      "cimer",
    ],
  },
  {
    name: "PKK",
    logo: "/companyImages/pkk.svg",
    url: "https://pkk.si/",
    category: ["Marketing i kreativne usluge"],
  },
];